import { useStoreActions } from "../../../contexts";
import { useMutationState } from "../../../hooks/reactQuery/useMutationState";
export const useResyncXero = _ref => {
  let {
    onSettled
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    mutate
  } = useMutationState({
    mutationFn: invoiceId => api.invoice.resyncXero(invoiceId),
    mutationName: 'Resync Xero',
    withPageLoader: true,
    toasts: {
      successMessage: 'Payment re-synced successfully',
      errorMessage: 'Failed to resync'
    },
    onSettled
  });
  return {
    resyncXero: mutate
  };
};